module.exports = __webpack_public_path__ + "img/7726f44.png";